<template>
   <div class="fixed z-[10000] w-full h-full top-0 left-0 flex items-center justify-center" >
      <div class="fixed w-full h-full bg-gray-500 opacity-50"></div>
      <div class="relative z-2 w-full xs:w-full md:w-1/3 bg-white p-8 mx-auto rounded-xl flex flex-col items-center">
        <p class="text-xl pb-4">Ukończono grę w {{ turns }} ruchów!</p>
        <button class="quiz-button text-white hover:text-white bg-ekopleszew-primary hover:bg-ekopleszew-light mt-4" @click="$emit('click')">Zagraj ponownie</button>
      </div>
    </div>
</template>

<script>
export default {
  name : 'modal-component',
  props : ['turns'],
}
</script>